import React from "react";

export default function MySQL_NOW() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_NOW</h1>
      <p>This is the MySQL_NOW component generated from the SQL JSON.</p>
    </div>
  );
}
